import { useState } from "react";
import { Button } from "@/components/ax/Button";
import { useI18n } from "@/i18n";

export const EPISTEMIC = ["KNOWN", "ASSUMED", "UNKNOWN"];

const tone = {
  KNOWN: { color: "var(--accent)", text: "var(--link)" },
  ASSUMED: { color: "var(--warning)", text: "var(--assumed-text)" },
  UNKNOWN: { color: "var(--muted)", text: "var(--muted)" },
};

export const EpistemicBadge = ({ value }) => {
  const { t } = useI18n();
  return (
    <span
      data-testid={`epistemic-badge-${value.toLowerCase()}`}
      style={{ borderColor: tone[value].color, color: tone[value].text }}
      className="inline-flex h-6 items-center rounded-[8px] border px-2 font-mono text-[13px] leading-[18px]"
    >
      {t(`epistemic.${value}`)}
    </span>
  );
};

export const EpistemicRow = ({ item, onChange, busy, readOnly = false }) => {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  return (
    <li
      data-testid={`item-row-${item.id}`}
      style={{ borderLeftColor: tone[item.epistemic].color }}
      className="list-none rounded-[12px] border border-l-[3px] border-ax-border bg-ax-surface p-4 shadow"
    >
      <div className="flex items-center gap-2">
        <EpistemicBadge value={item.epistemic} />
        {(readOnly || item.ref) && <span className="font-mono text-[13px] leading-[18px] text-ax-muted">{item.ref ?? item.id}</span>}
      </div>
      <p className="m-0 mt-2 text-base leading-6 text-ax-text [overflow-wrap:anywhere]">{item.text}</p>
      {!readOnly && (
      <Button
        variant="ghost"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        data-testid={`item-change-status-${item.id}`}
        className="mt-1 min-h-[44px] px-0"
      >
        {t("items.changeStatus")}
      </Button>
      )}
      {!readOnly && open && (
        <div className="mt-2 grid grid-cols-3 gap-2">
          {EPISTEMIC.map((value) => (
            <Button
              key={value}
              disabled={busy}
              onClick={async () => {
                await onChange(item.id, value);
                setOpen(false);
              }}
              data-testid={`item-${item.id}-set-${value.toLowerCase()}`}
              className="min-h-[44px] px-2 font-mono text-[13px]"
            >
              {t(`epistemic.${value}`)}
            </Button>
          ))}
        </div>
      )}
    </li>
  );
};
